module.exports = __webpack_public_path__ + "static/media/feeding1.180cda75.jpg";